import { render } from "./ThemePreferenceModal.vue?vue&type=template&id=72edf9fd&scoped=true"
import script from "./ThemePreferenceModal.vue?vue&type=script&lang=js"
export * from "./ThemePreferenceModal.vue?vue&type=script&lang=js"

import "./ThemePreferenceModal.vue?vue&type=style&index=0&id=72edf9fd&scoped=true&lang=css"
import "./ThemePreferenceModal.vue?vue&type=style&index=1&id=72edf9fd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72edf9fd"]])

export default __exports__